import { ReplyPathProvider } from "../../contexts";
import { ChatMessageList as ChatMessageListComponent } from "./chat-message-list";

export const ChatMessageList = () => (
  <ReplyPathProvider>
    <ChatMessageListComponent />
  </ReplyPathProvider>
);
